module.exports = __webpack_public_path__ + "img/Mockup_two.4a53ff87.png";